<template>
	<VListItem
		v-if="appSwitcher && hasItems"
		class="text-decoration-none pl-2"
		prepend-icon="$twi-app-switcher"
		:title="t('navigationMenu.teamworksApps')"
		data-testid="navigationAppSwitcherMenu"
		link
		aria-haspopup="menu"
		role="button"
	>
		<AppSwitcherMenu
			v-model="isMenuActive"
			:app-switcher="appSwitcher"
			activator="parent"
			theme="TwLight"
			data-testid="appSwitcherMenu"
		/>
		<VTooltip
			v-if="!isExpanded"
			activator="parent"
			location="right"
			:aria-label="t('navigationMenu.teamworksApps')"
		>
			{{ t('navigationMenu.teamworksApps') }}
		</VTooltip>
	</VListItem>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { AppSwitcherMenu } from '@teamworksdev/vuetify';
import { useAppSwitcher } from '@/composables/useAppSwitcher';

defineProps<{
	isExpanded: boolean;
}>();
const { t } = useI18n();

const isMenuActive = ref(false);

const { appSwitcher } = useAppSwitcher();

const hasItems = computed(() => (appSwitcher.value?.appList.length ?? 0) > 1);
</script>
